
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("lG0uN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c8039b0a5fe544f6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $10fdS = parcelRequire("10fdS");

var $dY715 = parcelRequire("dY715");

var $cjLTf = parcelRequire("cjLTf");

const $c8039b0a5fe544f6$var$AfterPaintIssuePreEval = ()=>{
    const route = (0, $10fdS.useCurrentRoute)();
    if ((0, $cjLTf.PREEVAL_ROUTES).has(route.name)) {
        (()=>{
            (0, $dY715.markAsBentoBundleReady)((parcelRequire("3kgCF")));
        })();
        performance.mark((0, $cjLTf.AFTER_PAINT_ISSUE_PREEVAL_MARK));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
};
var $c8039b0a5fe544f6$export$2e2bcd8739ae039 = $c8039b0a5fe544f6$var$AfterPaintIssuePreEval;

});
parcelRegister("dY715", function(module, exports) {

$parcel$export(module.exports, "markAsBentoBundleReady", () => $badbd94d97d705a8$export$d9ff0b3329728986);

var $hknOo = parcelRequire("hknOo");

var $2B87Z = parcelRequire("2B87Z");
let $badbd94d97d705a8$var$reportedBentoBundleReady = false;
const $badbd94d97d705a8$export$d9ff0b3329728986 = (importedBundle)=>{
    if (!false) importedBundle.then(()=>{
        // Mutex for reporter
        if ($badbd94d97d705a8$var$reportedBentoBundleReady) return;
        $badbd94d97d705a8$var$reportedBentoBundleReady = true;
        (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if (resources[i].name.startsWith('async-issue-app') && resources[i].name.endsWith((0, $hknOo.JS_EVAL_START))) {
            (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.eval', resources[i].name);
            break;
        }
    });
    return importedBundle;
};

});

parcelRegister("cjLTf", function(module, exports) {

$parcel$export(module.exports, "PREEVAL_ROUTES", () => $66dd54763592d1bb$export$8411da1302b7546c);
$parcel$export(module.exports, "AFTER_PAINT_ISSUE_PREEVAL_MARK", () => $66dd54763592d1bb$export$76f8f9afcfc4a896);

var $exb0h = parcelRequire("exb0h");
const $66dd54763592d1bb$export$8411da1302b7546c = new Set([
    (0, $exb0h.ROUTE_NAMES_ARCHIVED_PROJECTS_DIRECTORY),
    (0, $exb0h.ROUTE_NAMES_ARCHIVED_PROJECT_DIRECT_LINK),
    (0, $exb0h.ROUTE_NAMES_BOARDS_DIRECTORY),
    (0, $exb0h.ROUTE_NAMES_BUSINESS_BOARD),
    (0, $exb0h.ROUTE_NAMES_BUSINESS_CLASSIC_REPORTS),
    (0, $exb0h.ROUTE_NAMES_BUSINESS_REPORTS),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD_EMBED),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR_EMBED),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST_EMBED),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE_EMBED),
    (0, $exb0h.ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_CODE),
    (0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL),
    (0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL_INVALID),
    (0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT),
    (0, $exb0h.ROUTE_NAMES_CONNECT_PROJECT),
    (0, $exb0h.ROUTE_NAMES_DASHBOARDS_DIRECTORY),
    (0, $exb0h.ROUTE_NAMES_DASHBOARDS_DIRECTORY_SECURE),
    (0, $exb0h.ROUTE_NAMES_FILTERS_DIRECTORY),
    (0, $exb0h.ROUTE_NAMES_FILTERS_DIRECTORY_SECURE),
    (0, $exb0h.ROUTE_NAMES_FORGE_ADMIN),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_VIEW),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_VIEW),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_STATUSES),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TIME_TRACKING),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_DASHBOARD),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_FOCUS_PAGE),
    (0, $exb0h.ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_HOME),
    (0, $exb0h.ROUTE_NAMES_ISSUE_EMBED),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_LANDING),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH_ARTICLES),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_SETUP),
    (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS),
    (0, $exb0h.ROUTE_NAMES_OPSGENIE_SCHEDULE),
    (0, $exb0h.ROUTE_NAMES_PEOPLE_INDEX),
    (0, $exb0h.ROUTE_NAMES_PERSONAL_SETTINGS),
    (0, $exb0h.ROUTE_NAMES_POLARIS_IDEAS),
    (0, $exb0h.ROUTE_NAMES_POLARIS_INSIGHTS),
    (0, $exb0h.ROUTE_NAMES_POLARIS_PLAYS),
    (0, $exb0h.ROUTE_NAMES_POLARIS_ROOMS),
    (0, $exb0h.ROUTE_NAMES_PRODUCTS_JSW_CONFIGURATION),
    (0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY),
    (0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY_LEGACY_PATH_SPA),
    (0, $exb0h.ROUTE_NAMES_PROJECT_COMPONENTS),
    (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR),
    (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE),
    (0, $exb0h.ROUTE_NAMES_PROJECT_PAGES),
    (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_COMPONENTS),
    (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_VERSIONS),
    (0, $exb0h.ROUTE_NAMES_PROJECT_VERSIONS),
    (0, $exb0h.ROUTE_NAMES_RAPIDBOARD),
    (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG),
    (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD),
    (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED),
    (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_REPORT),
    (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG),
    (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_USER_BOARD),
    (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_USER_REPORT),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_CONFIGURE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CONNECT_PROJECT),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CREATE_PROJECT),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_BOARDS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_EARLY_ACCESS_ITSM),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_INCIDENTS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_INDEX),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ISSUES),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_JIRA_AUTOMATION),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PROJECT_CONVERSION),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_LANDING),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_NEW),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_SUMMARY),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_SERVICES),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_SERVICES_NEW),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS_NEW),
    (0, $exb0h.ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS),
    (0, $exb0h.ROUTE_NAMES_SERVICE_HUB_SERVICES),
    (0, $exb0h.ROUTE_NAMES_SERVICE_HUB_SERVICE_DETAILS),
    (0, $exb0h.ROUTE_NAMES_SETTINGS_CMDB_FIELD_CONFIG),
    (0, $exb0h.ROUTE_NAMES_SETTINGS_OAUTH_CREDENTIALS),
    (0, $exb0h.ROUTE_NAMES_SETTINGS_RECOMMENDATIONS),
    (0, $exb0h.ROUTE_NAMES_SETTINGS_VIEW_CUSTOM_FIELDS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_BACKLOG),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_BOARDS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_CODE),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_CODE_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_SECURITY),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_DEPLOYMENTS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_RELEASE_NOTES),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_ROADMAP),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_ROADMAP_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_TIMELINE),
    (0, $exb0h.ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC),
    (0, $exb0h.ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT),
    (0, $exb0h.ROUTE_NAMES_TRASH_PROJECTS_DIRECTORY),
    (0, $exb0h.ROUTE_NAMES_YOUR_WORK)
]);
const $66dd54763592d1bb$export$76f8f9afcfc4a896 = 'AfterPaintIssuePreEval:rendered';

});

parcelRegister("3kgCF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("kWrFZ"),
    $d1Cng("dsiAd"),
    $d1Cng("eNmuD"),
    $d1Cng("92sUi"),
    $d1Cng("i5RRW"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("4l5Cw")
]).then(()=>parcelRequire('gDUp5'));

});



//# sourceMappingURL=after-paint-issue-preeval.99aab9d1.js.map
